// @ts-strict-ignore
/** @jsx jsx */
/** @jsxFrag null */
import {jsx} from 'panel';

import {
  EntrySectionUpdates,
  QueryFilterEntry,
  RowLabelType,
  SelectorTypeDefinitions,
} from 'common/query-builder/query-entry-section/types';
import {StringOperator} from 'common/widgets/property-filter-menu/models/types';
// eslint-disable-next-line import/no-cycle
import {QueryEntrySectionEl} from 'common/query-builder/query-entry-section/panel';
import {getProjectId, getWorkspaceId} from 'common/report/util';
import {SvgIconEl} from 'common/components/svg-icon';
import {TooltipEl} from 'common/components/tooltip';
import {Placement} from 'common/components/tooltip/types';
import nonOverlappingSegmentsImg from 'common/assets/images/custom-groups/nonoverlapping-segments.svg';

import type {StringBucketPane} from './index';

export function template(this: StringBucketPane) {
  const segment = this.params.segment;
  const listProperty = this.params.listProperty;
  const filters = this.getFilters();

  const commonEntryParams: QueryFilterEntry = {
    filters: [],
    filterOnly: true,
    hideListQuantifier: true,
    quickDelete: true,
    suppressTracking: true,
    type: SelectorTypeDefinitions.Filter,
    event: this.createTemplateFilter(segment).getAttributes(),
  };
  const placeholderRow = {
    ...commonEntryParams,
    quickDelete: false,
    operatorOverrides: this.getFilterOperatorOverrides(filters.length),
  };

  const disableFilterSection = filters.length >= 10;

  return (
    <div sel='.mp-string-bucket-pane'>
      <div sel='.input-area'>
        <QueryEntrySectionEl
          containedSection
          indentFilters
          disableAddEntry
          disabled={disableFilterSection}
          rowIndex={0}
          rowLabelType={RowLabelType.None}
          addEntryButtonLabel='Select Value'
          entries={[
            ...filters.map((event, idx) => ({
              ...commonEntryParams,
              event,
              quickRename: event.filterOperator === StringOperator.Equals,
              operatorOverrides: this.getFilterOperatorOverrides(idx),
            })),
            placeholderRow,
          ]}
          eventNames={this.params.eventNames}
          projectId={parseInt(getProjectId())}
          workspaceId={parseInt(getWorkspaceId())}
          rowTypes={[{placeholderEntry: commonEntryParams, value: SelectorTypeDefinitions.Filter}]}
          trackProperties={{sectionName: `customize-string-group`}}
          onUpdate={(updates: EntrySectionUpdates<QueryFilterEntry>) => this.handleFiltersUpdate(updates)}
          onKeyUp={(ev) => ev.stopPropagation()} // TODO it's probably better to swallow key events at the property menu level instead
          {...(listProperty ? {listProperty} : {})}
        />
        <div sel='.remaining-values'>
          <span>{this.t(`query-builder.buckets.else-remaining`)}</span>
          <div sel='.help-icon'>
            <SvgIconEl attrs={{icon: `info-xs`}} />
            <TooltipEl
              attrs={{
                'image-src': nonOverlappingSegmentsImg,
                'max-width': `150px`,
                placement: Placement.RightCenter,
                text: this.t(`query-builder.buckets.remaining-tooltip`),
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
